import { render, staticRenderFns } from "./shopForm.vue?vue&type=template&id=4ac44f82&"
import script from "./shopForm.vue?vue&type=script&lang=js&"
export * from "./shopForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports